import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LocationIcon from '@mui/icons-material/Place';
import RouteIcon from '@mui/icons-material/TransferWithinAStation';

import { FormattedMessage, useIntl } from 'react-intl';
import InformationalSection from '~/components/InformationalSection';
import messages from './messages';

type Depot = {
  address?: string | null;
  city?: string | null;
  zip?: string | null;
  name?: string | null;
};

export const generateCrossPlatformGoogleMapsUrl = (depot: Depot) => {
  const query = encodeURIComponent(
    `${depot.address} ${depot.zip} ${depot.city}`
  );
  return `https://www.google.com/maps/search/?api=1&query=${query}`;
};

type OpenDepotInGoogleMapsButtonProps = {
  depot: Depot;
};

export const OpenDepotInGoogleMapsButton = ({
  depot,
  ...rest
}: OpenDepotInGoogleMapsButtonProps) => (
  <IconButton
    {...rest}
    href={generateCrossPlatformGoogleMapsUrl(depot)}
    target="_blank"
    rel="noopener noreferrer"
    size="large"
  >
    <OpenInNewIcon />
  </IconButton>
);

type LocationCardProps = {
  route: string;
  meetingPlace?: string | null;
  depot: Depot;
};

export const LocationCard = (props: LocationCardProps) => {
  const intl = useIntl();
  return (
    <InformationalSection title={<FormattedMessage {...messages.location} />}>
      <List disablePadding>
        <ListItem>
          <ListItemIcon>
            <RouteIcon />
          </ListItemIcon>
          <ListItemText
            primary={props.route}
            secondary={intl.formatMessage(messages.route)}
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <LocationIcon />
          </ListItemIcon>
          <ListItemText
            primary={props.depot.name}
            secondary={intl.formatMessage(messages.depot)}
          />
          <ListItemSecondaryAction>
            <OpenDepotInGoogleMapsButton depot={props.depot} />
          </ListItemSecondaryAction>
        </ListItem>
      </List>
    </InformationalSection>
  );
};

export default LocationCard;
